import { apiFetch } from './client';

export interface VirtualUser {
  id: string;
  user_id: string;
  display_name: string;
  mode: 'clone' | 'attach';
  item_count: number;
  attached_wardrobe_ids?: number[];
}

export interface WardrobeItem {
  cloth_id: string;
  id_type: 'cloth' | 'item';
  name: string;
  category: string;
  color: string;
  material: string;
  description: string;
  thumb: string;
  wardrobe_id?: number;
}

export interface WardrobeItemsResponse {
  mode: string;
  user_id: string;
  attached_wardrobe_ids: number[];
  items: WardrobeItem[];
  has_more: boolean;
  total: number;
}

export async function listVirtualUsers(): Promise<{ items: VirtualUser[]; total: number }> {
  return apiFetch('/v1/virtual-users');
}

export async function getVirtualUser(id: string): Promise<VirtualUser> {
  return apiFetch(`/v1/virtual-users/${encodeURIComponent(id)}`);
}

export interface WardrobeCategoryCountsResponse {
  mode: string;
  user_id: string;
  counts: Record<string, number>;
  total: number;
}

export async function listWardrobeCategoryCounts(
  id: string,
  params?: {
    search?: string;
    cluster?: string;
    color?: string;
  }
): Promise<WardrobeCategoryCountsResponse> {
  const qs = new URLSearchParams();
  if (params?.search) qs.set('search', params.search);
  if (params?.cluster) qs.set('cluster', params.cluster);
  if (params?.color) qs.set('color', params.color);
  return apiFetch(`/v1/virtual-users/${encodeURIComponent(id)}/wardrobe-category-counts?${qs.toString()}`);
}

export async function listWardrobeItems(
  id: string,
  params?: {
    category?: string;
    search?: string;
    cluster?: string;
    color?: string;
    limit?: number;
    offset?: number;
  }
): Promise<WardrobeItemsResponse> {
  const qs = new URLSearchParams();
  if (params?.category) qs.set('category', params.category);
  if (params?.search) qs.set('search', params.search);
  if (params?.cluster) qs.set('cluster', params.cluster);
  if (params?.color) qs.set('color', params.color);
  if (params?.limit != null) qs.set('limit', String(params.limit));
  if (params?.offset != null) qs.set('offset', String(params.offset));
  return apiFetch(`/v1/virtual-users/${encodeURIComponent(id)}/wardrobe-items?${qs.toString()}`);
}
